import React from 'react'
import type { Icon } from 'shared/utils'

export function SplitSearch(props: Icon) {
    const { size, color } = props

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 104 104">
            <g fill={color}>
                <path d="M61.36 17.274c-15.246 0-28.433 11.877-28.267 27.124.146 13.436 11.836 28.381 27.654 27.653 15.246 0 27.654-12.407 27.654-27.653 0-15.247-11.794-27.124-27.04-27.124zm-.613 44.408c-8.705-.03-16.214-7.8-17.295-17.295-1.082-9.474 7.758-17.295 17.295-17.295 9.651-.676 17.649 5.658 17.295 17.295-.291 9.527-7.758 17.327-17.295 17.295z"></path>
                <path d="M31.606 65.052c-1.935.156-3.942 1.206-5.419 2.683l-4.576 4.608-3.567 3.587c-1.58 1.581-2.517 3.672-2.433 5.658a5.404 5.404 0 001.612 3.682c1.32 1.32 3.536 3.047 5.262 3.047 1.726 0 4.638-1.28 5.96-2.6l3.598-4.14 3.702-4.274c1.092-1.092 2.465-2.922 2.662-4.586.27-2.371-1.112-4.67-2.662-6.22-1.154-1.154-2.62-1.57-4.129-1.445h-.01z"></path>
            </g>
        </svg>
    )
}
